import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAttractionDetails } from "../../redux/commonActionCreator";
import { attraction_details, attraction_path, attraction_related_packages } from "../../redux/commonReducer";
import { IMAGE_BASE_URL } from "../../constants/configuration";
import { activity } from "../../components/web/config";

export default function AttractionDetails() {
  const dispatch = useDispatch();
  const { id, packageId } = useParams();
  const navigate = useNavigate();

  const details = useSelector(attraction_details);
  const path = useSelector(attraction_path);
  const packages = useSelector(attraction_related_packages)

  const INITIAL_LIMIT = 5;
  const [visiblePackages, setVisiblePackages] = useState(INITIAL_LIMIT);

  const handleLoadMore = () => {
    setVisiblePackages(packages.length);
  };

  useEffect(() => {
    if (id) {
      if (packageId) {
        const row = {
          id,
          packageId,
        };
        dispatch(getAttractionDetails(row));
      } else {
        dispatch(getAttractionDetails(id));
      }
    }
  }, [id]);

  const nextLoader = () => { };

  return (
    console.log(details?.long_description, 'packages'),
    <div className="section__activities">
      <img
        className="main"
        src={`${IMAGE_BASE_URL}${path}/${details?.image}`}
        alt={details?.image_alt}
      />
      <div className="container">
        <div className="row">
          <div className={`${packages?.length == undefined || packages?.length == 0 ? "col-md-12" : 'col-md-8'}`}>
            <div
              className={`tag bg-secondary ${details?.attractions?.length ? "pointer" : ""
                }`}
              onClick={() =>
                details?.attractions?.length
                  ? navigate(
                    `/attraction-details/${details?.attractions?.[0].handle_key}`
                  )
                  : {}
              }
            >
              Attractions
            </div>
            <h1>
              {details?.title}
            </h1>
            <h2>
              Details
            </h2>
            <div
              className="detail-para ql-editor"
              dangerouslySetInnerHTML={{ __html: details?.long_description }}
            ></div>
          </div>
          {
            packages?.length > 0 &&
            <div className="col-md-4">
              <div className="related__packages">
                <h2>Related Packages</h2>
                {packages.slice(0, visiblePackages).map((ele, i) => (
                  <Link to={`/package-details/${ele?.handle_key}`} key={i}>
                    <div className="packages">
                      <div className="image">
                        <img
                          src={
                            ele?.thumbnail
                              ? `${IMAGE_BASE_URL}package/${ele?.thumbnail}`
                              : ""
                          }
                          alt=""
                        />
                      </div>
                      <div className="title">
                        <h3>{ele?.package_name}</h3>
                      </div>
                    </div>
                  </Link>
                ))}
                {visiblePackages < packages.length && (
                  <button onClick={handleLoadMore} className="loadmore">
                    Load More..
                  </button>
                )}
              </div>
            </div>
          }
        </div>

      </div>
      {details?.attractions?.length ? (
        <div className="more_activities">
          <div className="container">
            <h3>MORE ATTRACTIONS</h3>
            <Slider {...activity} arrows={details?.attractions?.length > 6}>
              {details?.attractions?.map((ele, i) => {
                return (
                  <div
                    className="gridItem"
                    onClick={() =>
                      navigate(`/attraction-details/${ele?.handle_key}`)
                    }
                  >
                    <img
                      src={`${IMAGE_BASE_URL}${path}/${ele?.image}`}
                      alt={ele.image_alt}
                    />
                    <h4>{ele?.title}</h4>
                    <h6 className="attraction">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: ele?.short_description,
                        }}
                      ></p>
                    </h6>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
